import axios from "axios";

// Interface opcional para a estrutura do token no localStorage
interface TokenStorage {
  token: string;
}

export default async function CheckToken(): Promise<boolean> {
  const url = window?.config?.REACT_APP_BASE_URL || "";

  const result = localStorage.getItem("1");

  if (result) {
    try {
      const parsedResult: TokenStorage = JSON.parse(result);

      const response = await axios.get(`${url}/authenticationTokenClient`, {
        headers: {
          Authorization: `Bearer ${parsedResult.token}`,
        },
      });

      return response.data?.message === "Token is valid";
    } catch (error) {
      console.error("Erro ao verificar token:", error);
      return false;
    }
  }

  return false;
}
